import { serviceMaker, methods, api } from "@/http/index.js";

export const getAutomationMasterTemplate = () =>
  serviceMaker(`/exceutionmaster/template`, methods.GET, api.NGB);

export const getAutomationMasterList = () =>
  serviceMaker(`/exceutionmaster`, methods.GET, api.NGB);

export const getAutomationMasterById = (id) =>
  serviceMaker(`/exceutionmaster?id=${id}`, methods.GET, api.NGB);

export const createAutomationMaster = (data) =>
  serviceMaker(`/exceutionmaster`, methods.POST, api.NGB, data);

export const updateAutomationMaster = (id, data) =>
  serviceMaker(`/exceutionmaster/${id}`, methods.PUT, api.NGB, data);

export const deleteAutomationMaster = (id) =>
  serviceMaker(`/exceutionmaster/${id}`, methods.DELETE, api.NGB);

export const getAutomationStep = (id) =>
  serviceMaker(`/automationstep?automationId=${id}`, methods.GET, api.NGB);

export const createAutomationStep = (data) =>
  serviceMaker(`/automationstep`, methods.POST, api.NGB, data);

export const updateAutomationStep = (id, data) =>
  serviceMaker(`/automationstep/${id}`, methods.PUT, api.NGB, data);

export const deleteAutomationStep = (id) =>
  serviceMaker(`/automationstep/${id}`, methods.DELETE, api.NGB);
